export const ALLOWED_DOMAINS = [
    "https://obenelectric.com",
    "https://uicw.obenev.obenelectric.com",
    "https://obenev.obenelectric.com",
];

export const ALLOWED_DOMAINS_DISPLAY = ALLOWED_DOMAINS.join(", ");

export const isValidRedirectUrl = (value) => {
    if (!value) return false;
    return ALLOWED_DOMAINS.some(
        (domain) => value === domain || value.startsWith(domain + "/")
    );
};

export const getUrlError = (value, fieldLabel) => {
    if (!value) return `${fieldLabel} is required`;
    if (!isValidRedirectUrl(value)) {
        return `Must use an allowed domain: ${ALLOWED_DOMAINS_DISPLAY}`;
    }
    return null;
};

// ✅ Normalize URL for comparison — strip trailing slash
export const normalizeUrl = (value) => value?.trim().replace(/\/+$/, "").toLowerCase();

// ✅ Check if from and to are the same
export const isSameUrl = (from, to) => normalizeUrl(from) === normalizeUrl(to);